

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, BrowserRouter as Router } from 'react-router-dom';

import { LoginModal, PageLoader } from "components";

import DashboardSidebar from '../navigation/dashboardSidebar/DashboardSidebar';
import Home from '../home/Home';
import RecursiveBillingSetup from '../recursiveBillingSetup/RecursiveBillingSetup';
import AdvancePaySetup from '../advancePaySetup/AdvancePaySetup';
import BillingUploadInvalidMessages from "../recursiveBillingSetup/BillingUploadInvalidMessages";
import ManualBilling from '../manualBilling/ManualBilling';
import NormalInvoices from '../invoices/normalInvoices/NormalInvoices';
import AdvancePayInvoices from '../invoices/advancePayInvoices/AdvancePayInvoices';
import DebitNote from "../debitNote/DebitNote";
import OutletStatusChange from "../outletStatusChange/OutletStatusChange";
import ComActivation from "../comActivation/ComActivation";
import ActivityLog from "../activityLog/ActivityLog";
import AccountControl from "../accountControl/AccountControl";
import TransactionHistory from "../transactionHistory/TransactionHistory";
import PerformedJournal from "../performedJournal/PerformedJournal";
import CompanyInfo from "../companyInfo/CompanyInfo";
import CommitmentPaySetup from '../commitmentPaySetup/commitmentPay/CommitmentPaySetup';
import SyncDownDebitNotes from '../commitmentPaySetup/syncDownDebitNotes/SyncDownDebitNotes';
import DebitNoteV2 from '../debitNoteV2/DebitNoteV2';
import MobileLicenseKeyControl from '../mobileLicenseKey/MobileLicenseKeyControl';

import POSCountReport from "../reporting/posCount/POSCount";
import BillingSetupReport from "../reporting/billingSetupReport/BillingSetupReport";
import Revenue from "../reporting/revenue/Revenue";
import TrialCOM from "../reporting/trialCOM/TrialCOM";
import StoreReport from "../reporting/storeReport/StoreReport";
import MobileLicenseKeyReport from '../mobileLicenseKey/MobileLicenseKeyReport';
import ProductSummaryReport from "../reporting/productSummaryReport/ProductSummaryReport";
import ActivationLog from "../reporting/activationLog/ActivationLog"; 
import ApiUsage from "../reporting/apiUsage/ApiUsage";

import SalesPerson_CreditNoteCommission from "../salesPersonCommReport/creditNoteCommission/CreditNoteCommission";
import SalesPerson_QuarterlyCommission from "../salesPersonCommReport/quarterlyCommission/QuarterlyCommission";
import SalesPerson_Settings from "../salesPersonCommReport/settings/Settings";
import SalesPerson_InvoiceCommission from "../salesPersonCommReport/invoiceCommission/InvoiceCommission";

import Dealer_CreditNoteCommission from "../dealerCommReport/creditNoteCommission/CreditNoteCommission";
import Dealer_QuarterlyCommission from "../dealerCommReport/quarterlyCommission/QuarterlyCommission";
import Dealer_Settings from "../dealerCommReport/settings/Settings";
import Dealer_InvoiceCommission from "../dealerCommReport/invoiceCommission/InvoiceCommission";

import UserList from '../userManagement/userList/UserList';
import UserGroup from '../userManagement/userGroup/UserGroup';
import Permission from '../userManagement/permission/Permission';

import { func_cookie, func_validation, func_url } from 'functions';

import { billingPortalBaseUrl } from "dataflow/billingPortal/constants";

import 'assets/scss/billingPortal/modules/dashboard.scss';
import { authenticationActions, userManagementActions } from 'dataflow/billingPortal/actions';



function DashboardPresentation(props) {
    const { isLoginModalVisible, userInfo, userPermissions } = props;

    // Check authentication
    useTokenAuthorization(props);

    // User Info
    let isAccessTokenValid = func_validation.isAccessTokenValid("access_token_bp");
    useEffect(() => {
        if ((func_validation.isObjectEmpty(userInfo) ||
            func_validation.isNullUndefined(userInfo)) &&
            func_validation.isRefreshTokenValid("refresh_token_bp") &&
            props.getUserInfo) {

            props.getUserInfo();
        }
        else if (func_validation.isObjectNotEmpty(userInfo)) {
            let role = func_validation.getObjectPropertyValue(userInfo, "Role");
            if (!func_validation.isStringEqual_caseInsensitive(role, "Internal")) {
                func_url.historyPushToURL(props, billingPortalBaseUrl + "login");
            }
        }
    }, [isAccessTokenValid]);

    useEffect(() => {
        let username = func_validation.getObjectPropertyValue(userInfo, "UserName", "");

        if (func_validation.isStringTrimNotEmpty(username) &&
            func_validation.isNullUndefined(userPermissions) &&
            props.getUserGroupPermission) {
            props.getUserGroupPermission(username);
        }
    }, [userInfo]);
    
    let isBillingSetupPagesViewable = func_validation.isUserAccessGranted(props, "Internal_BillingSetup_View");
    let isInvoicePagesViewable = func_validation.isUserAccessGranted(props, "Internal_ProformaInvoice_View");

    if (func_validation.isNullUndefined(userPermissions)) return (<PageLoader/>);

    return (
        <Router {...props}>
            <div className={"dashboard d-flex"}>
                {/* Login Modal having issue removing after successful login */}
                {/* <LoginModal
                    {...props}
                    refreshTokenCookieName={"refresh_token_bp"}
                    isModalVisible={isLoginModalVisible}
                    updateModalVisiblity_parentState={props.toggleLoginModalVisibility}
                    title={"Billing Portal"}
                /> */}

                {/* Sidebar */}
                <Route path={billingPortalBaseUrl + "dashboard"} render={(props) => (<DashboardSidebar {...props} />)} />

                <div id={"dashboard-main"} className={"dashboard-main flex-fill"}>
                    <Switch>
                        {isBillingSetupPagesViewable? (
                            <Route path={billingPortalBaseUrl + "dashboard/recursiveBillingSetup/billingUploadInvalidMessages"} render={(props) => (<BillingUploadInvalidMessages {...props} />)} />
                        ):""}
                        {isBillingSetupPagesViewable? (
                            <Route path={billingPortalBaseUrl + "dashboard/recursiveBillingSetup"} render={(props) => (<RecursiveBillingSetup {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_AdvancePay_View")? (
                            <Route path={billingPortalBaseUrl + "dashboard/commitment-pay-setup"} render={(props) => (<CommitmentPaySetup {...props} />)} />
                            // <Route path={billingPortalBaseUrl + "dashboard/commitment-pay-setup"} render={(props) => (<AdvancePaySetup {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_Commitment_Add")? (
                            <Route path={billingPortalBaseUrl + "dashboard/sync-down-debit-notes"} render={(props) => (<SyncDownDebitNotes {...props} />)} />
                        ):""}

                        {/* <Route path={billingPortalBaseUrl + "dashboard/companies"} render={(props) => (<CompanyManagement {...props} />)} /> */}

                        <Route path={billingPortalBaseUrl + "dashboard/manualBilling"} render={(props) => (<ManualBilling {...props} />)} />

                        {/* {isInvoicePagesViewable? (
                            <Route path={billingPortalBaseUrl + "dashboard/invoices/commitmentPay"} render={(props) => (<AdvancePayInvoices {...props} />)} />
                        ):""} */}

                        {isInvoicePagesViewable? (
                            <Route path={billingPortalBaseUrl + "dashboard/invoices"} render={(props) => (<NormalInvoices {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_DebitNote_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/debitNote"} render={(props) => (<DebitNoteV2 {...props} />)} />
                            // <Route path={billingPortalBaseUrl + "dashboard/debitNote"} render={(props) => (<DebitNote {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_User_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/userManagement/user"} render={(props) => (<UserList {...props} />)} />
                        ):""}
                        {func_validation.isUserAccessGranted(props, "Internal_UserGroup_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/userManagement/userGroup"} render={(props) => (<UserGroup {...props} />)} />
                        ):""}
                        {func_validation.isUserAccessGranted(props, "Internal_Permission_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/userManagement/permission"} render={(props) => (<Permission {...props} />)} />
                        ):""}

                        {/* {func_validation.isUserAccessGranted(props, "Internal_Report_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/report/outletList"} render={(props) => (<OutletList {...props} />)} />
                        ):""} */}
                        
                        {func_validation.isUserAccessGranted(props, "Internal_ComInfo_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/comActivation"} render={(props) => (<ComActivation {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_General_ViewActivityLog")?(
                            <Route path={billingPortalBaseUrl + "dashboard/activityLog"} render={(props) => (<ActivityLog {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_AccControl_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/comControlTools/comAccountControl"} render={(props) => (<AccountControl {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_License_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/comControlTools/mobileLicenseKeyControl"} render={(props) => (<MobileLicenseKeyControl {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_TransactionHist_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/comControlTools/transactionHistory"} render={(props) => (<TransactionHistory {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_PerformedLog_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/comControlTools/performedJournal"} render={(props) => (<PerformedJournal {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_OutletStatus_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/comControlTools/outletStatusChange"} render={(props) => (<OutletStatusChange {...props} />)} />
                        ):""}

                        {/* {func_validation.isUserAccessGranted(props, "Internal_Payment_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/alphyPayPayment"} render={(props) => (<AlphyPayPayment {...props} />)} />
                        ):""} */}

                        {func_validation.isUserAccessGranted(props, "Internal_MobileLicense_View")?(
                        <Route path={billingPortalBaseUrl + "dashboard/reporting/mobileLicenseKeyControl"} render={(props) => (<MobileLicenseKeyReport {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_TrialComReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/trialCOM"} render={(props) => (<TrialCOM {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_StoreReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/storeReport"} render={(props) => (<StoreReport {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_ActivationLog_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/activationLog"} render={(props) => (<ActivationLog {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_ApiUsage_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/apiUsage"} render={(props) => (<ApiUsage {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_UsageBillingReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/billingSetup"} render={(props) => (<BillingSetupReport {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_UsageBillingReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/productSummary"} render={(props) => (<ProductSummaryReport {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_PosCountReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/posCount"} render={(props) => (<POSCountReport {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_RevenueReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/revenue"} render={(props) => (<Revenue {...props} />)} />
                        ):""}

                        {/* Sales Person Commission Report */}
                        {func_validation.isUserAccessGranted(props, "Internal_SalesPersonReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/invoiceCommission"} render={(props) => (<SalesPerson_InvoiceCommission {...props} />)} />
                        ):""}
                        {func_validation.isUserAccessGranted(props, "Internal_SalesPersonReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/creditNoteCommission"} render={(props) => (<SalesPerson_CreditNoteCommission {...props} />)} />
                        ):""}
                        {func_validation.isUserAccessGranted(props, "Internal_SalesPersonReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/quarterlyCommission"} render={(props) => (<SalesPerson_QuarterlyCommission {...props} />)} />
                        ):""}
                        {func_validation.isUserAccessGranted(props, "Internal_SalesPersonReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/salesPersonCommission/settings"} render={(props) => (<SalesPerson_Settings {...props} />)} />
                        ):""}

                        {/* Dealer Commission Report */}
                        {func_validation.isUserAccessGranted(props, "Internal_DealerReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/dealerCommission/invoiceCommission"} render={(props) => (<Dealer_InvoiceCommission {...props} />)} />
                        ):""}
                        {func_validation.isUserAccessGranted(props, "Internal_DealerReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/dealerCommission/creditNoteCommission"} render={(props) => (<Dealer_CreditNoteCommission {...props} />)} />
                        ):""}
                        {func_validation.isUserAccessGranted(props, "Internal_DealerReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/dealerCommission/quarterlyCommission"} render={(props) => (<Dealer_QuarterlyCommission {...props} />)} />
                        ):""}
                        {func_validation.isUserAccessGranted(props, "Internal_DealerReport_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/reporting/dealerCommission/settings"} render={(props) => (<Dealer_Settings {...props} />)} />
                        ):""}

                        {func_validation.isUserAccessGranted(props, "Internal_ComInfoTools_View")?(
                            <Route path={billingPortalBaseUrl + "dashboard/companyInfo"} render={(props) => (<CompanyInfo {...props} />)} />
                        ):""}

                        <Route path={billingPortalBaseUrl + "dashboard"} render={(props) => (<Home {...props} />)} />

                        <Redirect to={billingPortalBaseUrl + "dashboard"} />
                    </Switch>

                </div>
            </div>
        </Router>

    );
}

function useTokenAuthorization(props) {
    const [intervalID, setIntervalID] = useState();
    const [isIntervalRemovalRequired, setIsIntervalRemovalRequired] = useState();

    function checkToken() {
        let isFromLoginPage = func_cookie.getCookieValue("in");

        if (!func_validation.isRefreshTokenValid("refresh_token_bp")) {

            if (isFromLoginPage &&
                func_validation.isFunction(props.toggleLoginModalVisibility)) {

                func_url.historyPushToURL(props, billingPortalBaseUrl + "login");
                // props.toggleLoginModalVisibility(true);
            }
            else {
                setIsIntervalRemovalRequired(true);
                func_url.historyPushToURL(props, billingPortalBaseUrl + "login");
            }

        }
    }
    useEffect(() => {
        // Check token regular intervals
        setIntervalID(setInterval(checkToken, 500));

        return () => {
            clearInterval(intervalID);
        }
    }, []);
    useEffect(() => {
        if (isIntervalRemovalRequired) clearInterval(intervalID);
    }, [isIntervalRemovalRequired]);
    // useEffect(() => {
    //     // Remove all cookies when hard refresh page
    //     window.addEventListener("beforeunload", () => { func_cookie.removeAllCookies()});
    //     return window.removeEventListener("beforeunload", () => func_cookie.removeAllCookies);
    // }, []);
}

function mapStateToProps(state) {
    const { 
        tokenDetails,
        isLoginModalVisible,

        login_requesting,
        login_status,
        login_errorMsg,
        isLoggedIn,

        logout_status,

        getUserInfo_requesting,
        userInfo,

        refreshAccessToken_requesting,
        refreshAccessToken_status
    } = state.authenticationReducers;

    const { userPermissions } = state.userManagementReducers;

	return {
        tokenDetails,
        isLoginModalVisible,

        login_requesting,
        login_status,
        login_errorMsg,
        isLoggedIn,

        logout_status,

        getUserInfo_requesting,
        userInfo,

        refreshAccessToken_requesting,
        refreshAccessToken_status,
        
        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        toggleLoginModalVisibility: (isVisible) => { dispatch(authenticationActions.toggleLoginModalVisibility(isVisible)); },
        login: (loginInfoObj) => { dispatch(authenticationActions.login(loginInfoObj)); },
        refreshAccessToken: (tokenInfo) => { dispatch(authenticationActions.refreshAccessToken(tokenInfo)); },

        getUserInfo: () => { dispatch(authenticationActions.getUserInfo()); },
        getUserGroupPermission: (username) => { dispatch(userManagementActions.getUserGroupPermission(username)); }
    };
}

const Dashboard = connect(mapStateToProps, mapDispatchToProps)(DashboardPresentation);

export default Dashboard;